import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store/store';
import { fetchProducts } from '../store/slices/licenseSlice';
import { helper } from '../utils/helper';
import BackButton from '../components/BackButton';
import { useTranslation } from 'react-i18next';
import { getTitlePluginName } from "../helpers/getTitlePluginName";

// Import new components
import TopPromo from '../components/license-buy/TopPromo';
import HowItWorks from '../components/license-buy/HowItWorks';
import LicenseBuyCards from '../components/license-buy/LicenseBuyCards';
import FAQ from '../components/license-buy/FAQ';
import WhyChoose from '../components/license-buy/WhyChoose';
import WorkExample from '../components/license-buy/WorkExample';
import ContactForm from '../components/license-buy/ContactForm';
import GetNow from '../components/license-buy/GetNow';

const LicenseBuyPage: React.FC = () => {
  const pluginName = helper.getParam('plugin');
  // Lieferbar is bundled with the Mobile App subscription; separate Lieferbar license no longer exists.
  const licenseType = pluginName === 'lieferbar' ? 'mobile' : (pluginName || 'default');

  return (
    <div className="license-buy-page">
      {/* <BackButton /> */}

      <TopPromo licenseType={licenseType} />

      <HowItWorks licenseType={licenseType} />

      <LicenseBuyCards
        licenseType={licenseType}
      />

      <FAQ licenseType={licenseType} />

      <WhyChoose licenseType={licenseType} />

      <WorkExample licenseType={licenseType} />

      <GetNow licenseType={licenseType} />

      <ContactForm licenseType={licenseType} />
    </div>
  );
};

export default LicenseBuyPage; 